/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { eventColor } from '@/modules/Flexigo/screens/Flexiride/events';
import flexirideService from '../../services/flexiride';

const requests = {
  REQUESTED: '',
  AWAITING_PLANNING: '',
  PLANNED: '',
  ASSIGNED: '',
  CHANGE_REQUEST: '',
  CHANGE_REQUEST_CANCELLED: '',
  CANCELLED: '',
  ENROUTE_TO_PICKUP: '',
  ENROUTE_TO_DROPOFF: '',
  COMPLETED: '',
};

export default {
  state: {
    eventColor,
    selectedOrder: null,
    pairRules: [],
  },

  mutations: {
    SET_SELECTED_ORDER(state, payload) {
      state.selectedOrder = payload;
    },
    SET_PAIR_RULES(state, payload) {
      state.pairRules = payload;
    },
  },

  actions: {
    async fetchPairRules({ commit }, requestType) {
      try {
        const response = await flexirideService.getPairRules(requestType);
        commit('SET_PAIR_RULES', response || []);
      } catch (error) {
        console.error('Error fetching pair rules:', error);
        commit('SET_PAIR_RULES', []);
      }
    },
  },

  getters: {
    selectedOrder(state) {
      return state.selectedOrder;
    },
    pairRules(state) {
      return state.pairRules;
    },
    hasPairRulesRestrictions(state) {
      return state.pairRules.some((rule) => {
        const { dayGroups } = rule;
        return (
          dayGroups && dayGroups.length > 0 && dayGroups.some((group) => group.windows && group.windows.length > 0)
        );
      });
    },
  },
};

/* eslint-enable no-param-reassign */
/* eslint-enable no-unused-vars */
